import React from 'react'
import Phone from '@components/fields/Phone'
import useDebounce from '@hooks/useDebounce'
import useEffect from '@hooks/useEffect'
import useMessage from '@hooks/useMessage'
import useRef from '@hooks/useRef'
import useState from '@hooks/useState'
import {useMutate} from 'apollo-hooks'
import gql from 'graphql-tag'
import {Field} from 'simple-react-form'

import styles from './styles.module.css'

export default function SessionPhone(props) {
  const {preferences, optionalPhone} = props
  const [phone, setPhone] = useState(preferences.sessionPhone)
  const lastSavedPhone = useRef()
  const [debouncedPhone] = useDebounce(phone, 500)
  const mutate = useMutate()
  const showMessage = useMessage()
  const savePhone = async phone => {
    try {
      if (phone === lastSavedPhone.current) return
      lastSavedPhone.current = phone
      await mutate({
        mutation: gql`
          mutation setUserPhonePreferences($websiteId: ID, $sessionPhone: String) {
            setUserPreferences(websiteId: $websiteId, sessionPhone: $sessionPhone) {
              _id
              websiteId
              sessionPhone
            }
          }
        `,
        variables: {
          websiteId: preferences.websiteId,
          sessionPhone: phone
        },
        optimisticResponse: {
          setUserPreferences: {
            ...preferences,
            sessionPhone: phone
          }
        }
      })
    } catch (error) {
      showMessage(error)
    }
  }

  useEffect(() => {
    if (debouncedPhone !== preferences.sessionPhone) {
      savePhone(debouncedPhone)
    }
  }, [preferences.sessionPhone, debouncedPhone])

  return (
    <div className={styles.container}>
      <div className="label">Número de teléfono {optionalPhone ? '(Opcional)' : null}</div>

      <Field
        fieldName="phone"
        type={Phone}
        onChange={setPhone}
        value={phone}
        onBlur={() => {
          setPhone(preferences.sessionPhone)
        }}
      />
    </div>
  )
}
